import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChecklistIcon(props: IconProps) {
    return <Icon {...props} iconKey={"checklist"}/>
}
